import { render, staticRenderFns } from "./allow_manage_subaccounts.vue?vue&type=template&id=318af393&"
import script from "./allow_manage_subaccounts.vue?vue&type=script&lang=js&"
export * from "./allow_manage_subaccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports